import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useInvoices from "../../data/useInvoices";
import usePartInvoice from "../../data/usePartInvoice";
import LoadingWheel from "../shared/LoadingWheel";
import CreditInvoiceModal from "../invoices/CreditInvoiceModal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useInvoiceMutations from "../../data/useInvoiceMutations";

export default function PartInvoiceExpandedRow({ part }: { part: any }) {
  const { invoice } = usePartInvoice(part.id!);
  const { downloadInvoice } = useInvoiceMutations();
  const navigate = useNavigate();

  const [creditModalOpen, setCreditModalOpen] = useState(false);

  if (invoice.isLoading) {
    return <LoadingWheel />;
  }

  if (!invoice.data?.data) {
    return <div className="p-4 italic text-gray-400">No invoice found for this part.</div>;
  }

  return (
    <div className="p-4 flex ">
      <CreditInvoiceModal
        open={creditModalOpen}
        setOpen={setCreditModalOpen}
        invoice={invoice.data?.data ?? null}
      />
      <ButtonInput
        label="View Invoice"
        isSubmit={false}
        onClick={() => navigate(`/invoices/${invoice.data?.data.id}`)}
        classes={" mr-4"}
      />
      <ButtonInput
        label="Return Part"
        isSubmit={false}
        onClick={() => setCreditModalOpen(true)}
        classes={"bg-red-500 hover:bg-red-600 mr-4"}
      />
      <ButtonInput
        label="Download Invoice"
        isSubmit={false}
        onClick={() => {
          downloadInvoice(invoice.data?.data.id!);
        }}
        classes={"!bg-emerald-500 hover:!bg-emerald-600"}
      />
    </div>
  )
}